<template>
  <div>
    <FieldsetModel
      :ui="uiBaseFieldset"
      :name="FIELDSET_NAMES.mobile"
      :ui-title="title"
      :ui-subtitle="subtitle"
    >
      <UiWrapper
        :name="FIELD_NAMES.phoneNumber"
        :label="label"
        :validations="validations"
        :on-change="resetOTPServiceAndFields()"
        :blocker="isValidOTP"
      >
        <InputText
          type="tel"
          :prefix="prefix"
          :maxlength="maxlength"
        />
      </UiWrapper>
    </FieldsetModel>
  </div>
</template>

<script>
import { InputText } from '@dunia/ui';
import * as conditions from '@/forms/conditions';
import {
  MOBILE_STARTING_NUMBER,
  MOBILE_NUMBER_LENGTH,
  DIGIT_CHARS,
} from '@/forms/constants/onboarding-logic';
import sharedComponentMixin from '@/forms/components/shared/shared-component-mixin';

export default {
  name: 'FieldsetEmail',

  props: {
    title: {
      type: String,
      default: 'Mobile',
    },
    subtitle: {
      type: String,
      default: 'We will send you an SMS with a link to verify your mobile number',
    },
    label: {
      type: String,
      default: 'Mobile number',
    },
    validations: {
      type: Array,
      default: () => ([
        {
          errorMessage: 'Invalid character',
          condition: conditions.patternCondition(DIGIT_CHARS),
          name: 'check-is-mobile-only-digits',
        },
        {
          errorMessage: 'Your phone must start with a 5',
          condition: conditions.patternCondition(MOBILE_STARTING_NUMBER),
          name: 'check-is-mobile-starting-number',
        },
        {
          errorMessage: 'Your phone must have 9 digits',
          condition: conditions.patternCondition(MOBILE_NUMBER_LENGTH),
          name: 'check-is-mobile-length',
        },
      ]),
    },
    prefix: {
      type: String,
      default: '+971',
    },
    maxlength: {
      type: Number,
      default: 9,
    },
  },

  mixins: [sharedComponentMixin],

  data: () => ({
    MOBILE_STARTING_NUMBER,
    MOBILE_NUMBER_LENGTH,
    DIGIT_CHARS,
  }),

  components: {
    InputText,
  },
};
</script>
